import { BusyIndicator } from "client/Components";
import { setTrackingId } from "client/Misc/utils";
import { createContext, PropsWithChildren, ReactElement, useContext, useMemo } from "react";
import styles from "./ContentWithRelevant.module.less";

export type ContentWithRelevantProps = {
	trackingId?: string;
};

export const ContentWithRelevant = (
	props: PropsWithChildren<ContentWithRelevantProps>
): ReactElement => {
	const {
		trackingId,
		children
	} = props;

	const contextData = useMemo(
		(): ContentWithRelevantContextData => ({
			trackingId
		}),
		[trackingId]
	);

	return (
		<div
			{...setTrackingId(trackingId)}
			className={styles.root}
		>
			<div className={styles.layout}>
				<ContentWithRelevantContext.Provider value={contextData}>
					{children}
				</ContentWithRelevantContext.Provider>
			</div>
		</div>
	);
};
ContentWithRelevant.displayName = "ContentWithRelevant";

export type ContentWithRelevantContentProps = {
	hasBusyIndicator?: boolean;
};

export const ContentWithRelevantContent = (props: PropsWithChildren<ContentWithRelevantContentProps>): ReactElement => {
	const {
		hasBusyIndicator,
		children
	} = props;

	const { trackingId } = useContext(ContentWithRelevantContext);

	return (
		<div className={styles.content}>
			{hasBusyIndicator && <BusyIndicator />}
			<div {...setTrackingId(trackingId, "__content")} className={styles.host}>
				{children}
			</div>
		</div>
	);
};
ContentWithRelevantContent.displayName = "ContentWithRelevant.Content";

export type ContentWithRelevantRelevantProps = {
	title: string;
};

export const ContentWithRelevantRelevant = (props: PropsWithChildren<ContentWithRelevantRelevantProps>): ReactElement => {
	const {
		title,
		children
	} = props;

	const { trackingId } = useContext(ContentWithRelevantContext);

	return (
		<div
			{...setTrackingId(trackingId, "__relevant")}
			className={styles.relevant}
		>
			<div className={styles.host}>
				<h3 className={styles.relevantTitle}>
					{title}
				</h3>
				{children}
			</div>
		</div>
	);
};
ContentWithRelevantRelevant.displayName = "ContentWithRelevant.Relevant";

type ContentWithRelevantContextData = {
	trackingId: string | undefined;
};

const ContentWithRelevantContext = createContext<ContentWithRelevantContextData>({
	trackingId: undefined
});

ContentWithRelevant.Content = ContentWithRelevantContent;
ContentWithRelevant.Relevant = ContentWithRelevantRelevant;